import React from "react";
import { array, bool } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./organism1.m.css";

const Organism1 = ({ stories, isMobile }) => {
  return (
    <div styleName="wrapper">
      {stories.splice(0, 1).map((story, index) => (
        <NewsWithImage story={story.story} key={index} cssStyleName="mediumBigSize" showExcerpt={!isMobile} />
      ))}
      {stories.map((story, index) => (
        <LeftImageRightNews story={story.story} key={index} showExcerpt={false} />
      ))}
    </div>
  );
};

Organism1.propTypes = {
  stories: array.isRequired,
  isMobile: bool,
};

export default Organism1;
